import { APP_PREFIX_PATH } from 'configs/AppConfig';
import React from 'react'

export class DashboardProtectedRoute {

    static dashboards = [
        {
            key: 'liste-vendite',
            path: `${APP_PREFIX_PATH}/dashboards/vendite/liste`,
            component: React.lazy(() => import('views/app-views/liste-vendite')),
        },
        {
            key: 'dashboards-vendite',
            path: `${APP_PREFIX_PATH}/dashboards/vendite`,
            component: React.lazy(() => import('views/app-views/vendite')),
        },
        {
            key: 'dashboards-scandenze',
            path: `${APP_PREFIX_PATH}/dashboards/scadenze`,
            component: React.lazy(() => import('views/app-views/scadenze')),
        },
    ];

    static dashboardsContabile = [
        {
            key: 'dashboards-vendite',
            path: `${APP_PREFIX_PATH}/dashboards/vendite`,
            component: React.lazy(() => import('views/app-views/vendite')),
        }
    ];

    static dashboardsSuperadmin = [
        ...this.dashboards,
        {
            key: 'dashboards-statistiche',
            path: `${APP_PREFIX_PATH}/dashboards/statistiche`,
            component: React.lazy(() => import('views/app-views/statistiche')),
        }
    ];


    static getNavTree() {
        return this.dashboards;
    }

    static getNavTreeSuperadmin() {
        console.log("this.dashboardsSuperadmin", this.dashboardsSuperadmin)
        return this.dashboardsSuperadmin;
    }

    static getNavTreeContabile() {
        return this.dashboardsContabile;
    }
}

export default DashboardProtectedRoute;
